// extracted by mini-css-extract-plugin
export default {"container":"Services_container__1aoeh","services":"Services_services__NHXr5","service-card":"Services_service-card__Tb-6t"};